module.exports = __webpack_public_path__ + "img/slider-banner-2.202ae03b.jpg";